import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router';
import { Spinner } from '@skupreme/shared/ui';
import { useQueryClient } from '@tanstack/react-query';
import { Header } from '../components/Header';
import { hasStoredRefreshToken, refreshSession } from './session';
import { useSignedIn } from './useSession';

/** Routes inside need a session. A tab reloaded mid-session first trades its refresh token for an access token. */
export function RequireAuth() {
  const signedIn = useSignedIn();
  const queryClient = useQueryClient();
  const [restoring, setRestoring] = useState(
    () => !signedIn && hasStoredRefreshToken(),
  );

  useEffect(() => {
    if (restoring) {
      void refreshSession().finally(() => setRestoring(false));
    }
  }, [restoring]);

  useEffect(() => {
    if (!signedIn) {
      queryClient.clear();
    }
  }, [signedIn, queryClient]);

  if (restoring) {
    return (
      <div className="sk:flex sk:justify-center sk:py-16">
        <Spinner label="Restoring session" />
      </div>
    );
  }
  if (!signedIn) {
    return <Navigate to="/login" replace />;
  }
  return (
    <>
      <Header />
      <main className="sk:mx-auto sk:max-w-6xl sk:p-6">
        <Outlet />
      </main>
    </>
  );
}
